// statTile.js
// Pure computation for capture-tab-schema.json's list.stats[]/tracker.stats[]
// (statTile): a count of items matching a fieldPredicate, optionally
// restricted to items where a static item property is truthy (the itemProp
// AND-condition). Extracted from GenericCaptureRenderer.jsx's ListBlock so
// this logic has direct test coverage -- the itemProp path shipped with S8
// without a test and the config was missing the mustHave property it
// depends on, which silently produced 0/0.
import { evaluateFieldPredicate } from "./fieldPredicate";

export function computeStatTile(items, stat, getItemData) {
  const universe = stat.itemProp ? items.filter(function (it) { return !!it[stat.itemProp]; }) : items;
  const count = universe.filter(function (it) { return evaluateFieldPredicate(stat, getItemData(it)); }).length;
  const total = universe.length;
  return { count: count, total: total };
}
